import $vuetify from 'vuetify/es5/locale/pt';

export default {
  $vuetify,
  save: 'Save',
  close: 'Close',
  delete: 'Delete',
  confirm: 'Confirm',
  select: 'Select',
  edit: 'Edit',
  copy: 'Copy',
  active: 'Active',
  inactive: 'Inactive',
  download: 'Download',
  deleteAll: 'Delete All',
  unlinkAll: 'Unlink All',
  linkAll: 'Link All',
  selectAll: 'Select All',
  fieldRequired: 'This field is required',
  dialogDelete: {
    title: 'Do you want to delete the item?',
    message: 'The item will be permanently removed. Are you sure you want to continue?',
    observationNote: 'Note',
    alertTitle: 'You are about to perform a permanent deletion!',
    defaultMessage: 'This action cannot be undone.',
  },
  applications: {
    application: 'Application',
    applications: 'Applications',
    newApplication: 'New Application',
    name: 'Name',
    description: 'Description',
    alias: 'Alias',
    createdSuccess: 'Application created',
    updatedSuccess: 'Application updated',
    findError: 'Application not found',
    removeMessage: 'Are you sure you want to remove the application?',
    removeTitle: 'Remove application',
    versions: 'Versions',
  },
  versions: {
    versions: 'Versions',
    version: 'Version',
    name: 'Name',
    description: 'Description',
    url: 'URL',
    findError: 'Version not found',
    createdSuccess: 'Version created',
    updatedSuccess: 'Version updated',
    major: 'Major',
    minor: 'Minor',
    patch: 'Patch',
    generatedAt: 'Generated At',
    hidden: 'Hidden',
    invalidExtension: 'Only .apk files are allowed.',
    fileRequired: 'You need to add an application to create a version',
    dontChangeUrl: 'Keep the same URL',
    removeMessage: 'Are you sure you want to remove the version?',
  },
  companies: {
    companies: 'Companies',
    tradingName: 'Name',
    cnpj: 'CNPJ',
    removeMessage: 'Are you sure you want to remove the company?',
  },
  companyapplications: {
    companyapplications: 'Applications',
    applications: 'Applications',
    name: 'Name',
    description: 'Description',
    removeMessage: 'Are you sure you want to remove the application?',
  },
  users: {
    users: 'Users',
    firstName: 'First Name',
    username: 'Username',
    email: 'Email',
    removeMessage: 'Are you sure you want to unlink the version from the user?',
    thereAreVersionsAvailable: 'There are newer versions available',
  },
};
